module.exports = __webpack_public_path__ + "static/media/iheartradio.1600be68.svg";